import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Dashboard from './pages/Dashboard.tsx';
import SignIn from './pages/auth/signin.tsx';
import SignUp from './pages/auth/signup.tsx';
import VerifyOTPSignin from './pages/auth/verifyotp_signin.tsx';
import VerifyOTPSignup from './pages/auth/verifyotp_signup.tsx';
import UserProfile from './pages/user_profile.tsx';
import Cart from './pages/cart.tsx';
import PaymentMethod from './pages/payment_method.tsx';
import ConfirmOrder from './pages/order_confirm.tsx';
import OrderPlaced from './pages/order_placed.tsx';
import PasswordAssistance from './pages/auth/reset_app_password/password_assistance.tsx';
import AP_Email_Verification from './pages/auth/reset_app_password/ap_email_verification.tsx';
import AP_Number_Verification from './pages/auth/reset_app_password/ap_number_verification.tsx';
import ResetNewPassword from './pages/auth/reset_app_password/reset_new_password.tsx';
import Product from './pages/product.tsx';
import ProductDetail from './pages/product_detail.tsx';
import StripeCheckout from './pages/static_stripe_checkout.tsx';
import ViewOrder from './pages/view_order.tsx';
import AdminDashboard from './pages/admin/adminDashboard.tsx';
import ManageProduct from './pages/admin/manageProductsList.tsx';
import Slidemenu from './components/admin/adminSlidemenu.tsx';
import AdminHeader from './components/admin/adminHeader.tsx';
import OrderManagement from './components/admin/adminSlidemenu.tsx';
import Addproduct from './pages/admin/addproduct.tsx';
import CategoryManagement from './pages/admin/catergoryManagement.tsx';
import Banner from './pages/admin/banner.tsx';
import SubBanner from './pages/admin/subBanner.tsx';
import DealOfTheDay from './pages/admin/dealoftheday.tsx';
import SmptSettings from './pages/admin/smtpsettings.tsx';
import GlobalSettings from './pages/admin/globalSettings.tsx';
import SmsSettings from './pages/admin/smsSettings.tsx';
import UnitManagement from './pages/admin/unitManagement.tsx';
import AdminOrderManagement from './pages/admin/adminOrderManagement.tsx';
import SubCategoryManagement from './pages/admin/subCategoryMangement.tsx';
import Analytics from './pages/admin/analytics.tsx';
import PickupMessage from './pages/admin/pickupMessage.tsx';
import AdminLogin from './pages/admin/adminlogin.tsx';
import DeliveryManagement from './pages/admin/DeliveryManagement.tsx';
import ShippingManagement from './pages/admin/shippingManagement.tsx';
import ProductManagement from './pages/admin/productManagement.tsx';
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Reviews } from '@mui/icons-material';
import ReviewManagement from './pages/admin/review.tsx';
import SetCredit from './pages/admin/setCredit.tsx';
import GuestOrderList from './pages/admin/guestOrderlist.tsx';
import GuestUserOrder from './pages/admin/guestUserOrder.tsx';
import VendorLogin from './pages/admin/vendorlogin.tsx';
import UserList from './pages/admin/Userlist.tsx';
import FlashSale from './pages/admin/flashSale.tsx';
import Bundle from './pages/admin/bundle.tsx';
import DeliveryAgentManagement from './pages/admin/deliveryAgent.tsx';
import WareHoueManagement from './pages/admin/warehouseManagement.tsx';
import WarrantyManagement from './pages/admin/WarrantyManagement.tsx';
import ProductWarehouseManagement from './pages/admin/ProductWarehouseManagement.tsx';
import CouponManagement from './pages/admin/couponManagement.tsx';
import RewardManagement from './pages/admin/RewardManagement.tsx';
import RewardSettingsManagement from './pages/admin/RewardSettingsManagement.tsx';
import AdminRewards from './pages/admin/AdminRewards.tsx';
import AdminCouponUsers from './pages/admin/AdminCouponUsers.tsx';
import Delivery from './pages/admin/deliverySettings.tsx';
import RegisterAdmin from './pages/admin/registeradmin.tsx';
import RoleMaster from './pages/admin/roleMaster.tsx';
import RoleMappingManagement from './pages/admin/roleMapping.tsx';




function App() {
  return (
    <>
      <ToastContainer />
      <Router>
        <Routes>
          <Route path="/" element={<AdminLogin />} />
          <Route path="/signin" element={<SignIn />} />
          <Route path="/signup" element={<SignUp />} />
          <Route path="/otp-verification-signin" element={<VerifyOTPSignin />} />
          <Route path="/otp-verification-signup" element={<VerifyOTPSignup />} />
          <Route path="/ap" element={<PasswordAssistance />} />
          <Route path="/ap-email-verification" element={<AP_Email_Verification />} />
          <Route path="/ap-number-verification" element={<AP_Number_Verification />} />
          <Route path="/reset-ap" element={<ResetNewPassword />} />
          <Route path="/my-account" element={<UserProfile />} />
          <Route path="/cart" element={<Cart />} />
          <Route path="/payment-method" element={<PaymentMethod />} />
          <Route path="/confirm-order" element={<ConfirmOrder />} />
          <Route path="/order-placed" element={<OrderPlaced />} />
          <Route path="/view-order" element={<ViewOrder />} />
          <Route path="/products" element={<Product />} />
          <Route path="/product-detail" element={<ProductDetail />} />
          <Route path="/stripe-checkout" element={<StripeCheckout />} />
          <Route path="/adminDashboard" element={<AdminDashboard />} />
          <Route path="/manageproduct" element={<ManageProduct />} />
          <Route path="/adminHeader" element={<AdminHeader onToggleMenu={undefined} />} />
          <Route path="/slidemenu" element={<Slidemenu mobileOpen={false} onToggle={function (): void {
            throw new Error('Function not implemented.');
          }} />} />
          <Route path="/orderManagement" element={<OrderManagement mobileOpen={false} onToggle={function (): void {
            throw new Error('Function not implemented.');
          } }  />} />
          <Route path="/addproduct" element={<Addproduct />} />
          <Route path="/subcategorymanagement" element={<SubCategoryManagement />} />
          <Route path="/categorymanagement" element={<CategoryManagement />} />
          <Route path="/ProductManagement" element={<ProductManagement />} />
          <Route path="/banner" element={<Banner />} />
          <Route path="/subbanner" element={<SubBanner />} />
          <Route path="/dealoftheday" element={<DealOfTheDay />} />
          <Route path="/smptsettings" element={<SmptSettings />} />
          <Route path="/globalSettings" element={<GlobalSettings />} />
          <Route path="/smsSettings" element={<SmsSettings />} />
          <Route path="/unitmanagement" element={<UnitManagement />} />
          <Route path="/adminorderManagement" element={<AdminOrderManagement />} />
          <Route path="/analytics" element={<Analytics />} />
          <Route path="/pickupmessage" element={<PickupMessage />} />
          <Route path="/deliveryManagement" element={<DeliveryManagement />} />
          <Route path="/shippingManagement" element={<ShippingManagement />} />
          <Route path="/review" element={<ReviewManagement />} />
          <Route path="/setcredit" element={<SetCredit />} />
          <Route path="/guestorderlist" element={<GuestOrderList />} />
          <Route path="/guestuserorder" element={<GuestUserOrder />} />
          <Route path="/userlist" element={<UserList />} />
          <Route path="/adminlogin" element={<AdminLogin />} />
          <Route path="/vendorlogin" element={<VendorLogin />} />
          <Route path="/flashSale" element={<FlashSale />} />
          <Route path="/bundle" element={<Bundle />} />
          <Route path="/deliveryAgentManagement" element={<DeliveryAgentManagement />} />
          <Route path="/WareHouseManagement" element={<WareHoueManagement />} />
          <Route path="/WarrantyManagement" element={<WarrantyManagement />} />
          <Route path="/ProductWarehouseManagement" element={<ProductWarehouseManagement />} />
          <Route path="/couponManagement" element={<CouponManagement />} />
          <Route path="/rewardManagement" element={<RewardManagement />} />
          <Route path="/RewardSettingsManagement" element={<RewardSettingsManagement />} />
          <Route path="/AdminRewards" element={<AdminRewards />} />
          <Route path="/AdminCouponUsers" element={<AdminCouponUsers />} />
          <Route path="/deliverySettings" element={<Delivery />} />
          <Route path="/RegisterAdmin" element={<RegisterAdmin />} />
          <Route path="/roleMaster" element={<RoleMaster />} />
          <Route path="/RoleMapping" element={<RoleMappingManagement />} />
        </Routes>  
      </Router>
    </>
  );
}

export default App;